import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({ selector: "[drag-scroll]" })
export class DragScrollDirective {
    private dragging: Boolean = false;
    private mouseDownEvent;

    constructor(private el: ElementRef) {}

    mousedownHandler = (e) => {
        //catch mousemove event
        this.el?.nativeElement.addEventListener("mousemove", this.dragStartHandler);
        //catch mouseup event
        this.el?.nativeElement.addEventListener("mouseup", this.clickHandler);

        this.mouseDownEvent = e;
    };

    clickHandler = (e) => {
        this.el?.nativeElement.removeEventListener("mousemove", this.dragStartHandler);
        this.el?.nativeElement.removeEventListener("mouseup", this.clickHandler);
    };

    dragStartHandler = (e) => {
        if (!this.dragging) {
            this.el?.nativeElement.removeEventListener("mouseup", this.clickHandler);
            this.el?.nativeElement.addEventListener("mouseup", this.dragEndHandler);
            this.dragging = true;
        }
        this.horizontalScroll(e);
    };

    dragEndHandler = (e) => {
        if (this.dragging) {
            this.el?.nativeElement.removeEventListener("mousemove", this.dragStartHandler);
            this.el?.nativeElement.removeEventListener("mouseup", this.clickHandler);
            this.el?.nativeElement.removeEventListener("mouseup", this.dragEndHandler);
            this.dragging = false;
        }
    };

    horizontalScroll(e) {
        e.preventDefault();
        if (e.pageX > 0 && e.pageX < screen.width) {
            this.el.nativeElement.scrollLeft =
                this.el.nativeElement.scrollLeft + -1 * (e.clientX - this.mouseDownEvent.clientX);
        } else {
            console.log("no scroll");
        }
    }

    //get element on mousedown
    @HostListener("mousedown", ["$event"])
    onMousedown(event) {
        event.preventDefault();
        this.mousedownHandler(event);
    }

    @HostListener("mouseup", ["$event"])
    onMouseUp(event) {
        this.dragging = true;
        this.dragEndHandler(event);
    }
}
